import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import css from "./DishDuplicateModal.module.css";
import { toast } from "react-toastify";
import { dishesService } from "../../../../services/dishes-services";
import { Button } from "antd";

const DishDuplicateModal = ({
  setIsOpen,
  selectedDish,
  setSelectedDish,
  setIsOpenUpdate,
}) => {
  console.log(selectedDish);
  const [nameEn, setNameEn] = useState(selectedDish?.name?.en || "");
  const [nameRu, setNameRu] = useState(selectedDish?.name?.ru || "");
  const [nameKa, setNameKa] = useState(selectedDish?.name?.ge || "");
  const [quantity, setQuantity] = useState("1");
  const [isLoading, setIsLoading] = useState(false);

  // Calculate multiplied nutritional values
  const multiplier = parseFloat(quantity) || 1;
  const calculatedValues = {
    weight: Math.round((selectedDish?.weight || 0) * multiplier),
    weightNetto: Math.round((selectedDish?.weightNetto || 0) * multiplier),
    energy: Math.round((selectedDish?.energy || 0) * multiplier * 100) / 100,
    proteins:
      Math.round((selectedDish?.proteins || 0) * multiplier * 100) / 100,
    fats: Math.round((selectedDish?.fats || 0) * multiplier * 100) / 100,
    carbs: Math.round((selectedDish?.carbs || 0) * multiplier * 100) / 100,
  };

  const { t } = useTranslation();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setIsLoading(true);
      const newDish = await dishesService.duplicateDishesById(
        selectedDish.id,
        quantity,
        {
          en: nameEn,
          ru: nameRu,
          ge: nameKa,
        }
      );
      setIsOpen(false);
      setSelectedDish(newDish);
      setIsOpenUpdate(true);
      toast.success(t("toast-dish-duplicated"));
    } catch (error) {
      console.error("Error duplicating dish:", error);
      toast.error(t("toast-dish-duplicate-failed"));
    } finally {
      setIsLoading(false);
    } 
  };

  //   const handleDuplicateClick = async (id) => {
  //     try {
  //       const newDish = await dishesService.duplicateDishesById(id);
  //       dispatch(dishesActions.changeTrigger());
  //       handleRowClick();
  //       setIsOpenDuplicateModal(true);
  //       toast.success(t("toast-dish-duplicated"));
  //     } catch (error) {
  //       console.error("Error duplicating dish:", error);
  //       toast.error(t("toast-dish-duplicate-failed"));
  //     }
  //   };

  return (
    <section className={css.overlay}>
      <div className={css.modal}>
        <div className={css.header}>
          <div className={css.title}>{t("Duplicate Dish")}</div>
          <div className={css.closeButton} onClick={() => setIsOpen(false)}>
            ×
          </div>
        </div>

        <form onSubmit={handleSubmit} className={css.form}>
          <div className={css.content}>
            <div className={css.selectedDish}>
              <label>{t("Selected Dish")}:</label>
              <span>{selectedDish?.name.en || "No dish selected"}</span>
            </div>

            <div className={css.inputGroup}>
              <label htmlFor="nameEn">{t("Name")} (English):</label>
              <input
                id="nameEn"
                type="text"
                value={nameEn}
                onChange={(e) => setNameEn(e.target.value)}
                placeholder={t("Enter dish name in English")}
                className={css.input}
              />
            </div>

            <div className={css.inputGroup}>
              <label htmlFor="nameRu">{t("Name")} (Русский):</label>
              <input
                id="nameRu"
                type="text"
                value={nameRu}
                onChange={(e) => setNameRu(e.target.value)}
                placeholder={t("Enter dish name in Russian")}
                className={css.input}
              />
            </div>

            <div className={css.inputGroup}>
              <label htmlFor="nameKa">{t("Name")} (ქართული):</label>
              <input
                id="nameKa"
                type="text"
                value={nameKa}
                onChange={(e) => setNameKa(e.target.value)}
                placeholder={t("Enter dish name in Georgian")}
                className={css.input}
              />
            </div>

            <div className={css.inputGroup}>
              <label htmlFor="quantity">
                {t("Multiplier")} (1x, 2x, 1.5x):
              </label>
              <input
                id="quantity"
                type="number"
                step="any"
                value={quantity}
                onChange={(e) => setQuantity(e.target.value)}
                placeholder="1"
                className={css.input}
              />
            </div>

            {/* Nutritional Information */}
            <div className={css.nutritionalInfo}>
              <h4 className={css.sectionTitle}>
                {t("Nutritional Information")} ({multiplier}x)
              </h4>
              <div className={css.nutritionalGrid}>
                <div className={css.nutritionalItem}>
                  <span className={css.label}>{t("Weight")}:</span>
                  <span className={css.value}>{calculatedValues.weight}g</span>
                </div>
                <div className={css.nutritionalItem}>
                  <span className={css.label}>{t("Weight Net")}:</span>
                  <span className={css.value}>
                    {calculatedValues.weightNetto}g
                  </span>
                </div>
                <div className={css.nutritionalItem}>
                  <span className={css.label}>{t("Energy")}:</span>
                  <span className={css.value}>
                    {calculatedValues.energy} kcal
                  </span>
                </div>
                <div className={css.nutritionalItem}>
                  <span className={css.label}>{t("Proteins")}:</span>
                  <span className={css.value}>
                    {calculatedValues.proteins}g
                  </span>
                </div>
                <div className={css.nutritionalItem}>
                  <span className={css.label}>{t("Fats")}:</span>
                  <span className={css.value}>{calculatedValues.fats}g</span>
                </div>
                <div className={css.nutritionalItem}>
                  <span className={css.label}>{t("Carbs")}:</span>
                  <span className={css.value}>{calculatedValues.carbs}g</span>
                </div>
              </div>
            </div>
          </div>

          <div className={css.buttonsBlock}>
            <Button
              type="default"
              onClick={() => setIsOpen(false)}
              disabled={isLoading}
              loading={isLoading}
            >
              {t("Cancel")}
            </Button>
            <Button
              type="primary"
              onClick={handleSubmit}
              disabled={isLoading}
              loading={isLoading}
            >
              {t("Duplicate")}
            </Button>
          </div>
        </form>
      </div>
    </section>
  );
};

export { DishDuplicateModal };
